"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const Cell = ({
  startAlign,
  centerAlign,
  children,
  colSpan,
  endAlign,
  header,
  truncate,
  wrap,
  ...props
}) => {
  const Tag = header ? 'th' : 'td';
  return (0, _jsxRuntime.jsx)(Tag, {
    ...props,
    css: () => [_styles.styles.cell_defaults, startAlign && _styles.styles.cell_left, centerAlign && _styles.styles.cell_center, endAlign && _styles.styles.cell_right, truncate && _styles.styles.cell_truncate, wrap && _styles.styles.cell_wrap],
    children: children
  });
};
var _default = exports.default = Cell;